import logo from 'images/logo.svg';

import { footerContainer, logoContainer, copyRight, linkContainer, header, link } from './footer.module.scss';
import { LayoutContainer } from 'layout/layoutContainer';
import { footerSections } from './footer-section';
import React from 'react';

export const Footer = () => {
    return (
        <LayoutContainer>
            <footer className={footerContainer}>
                <div className={linkContainer}>
                    <div className={logoContainer}>
                        <img src={logo} alt="elumity logo" />
                        <p className={copyRight}>&copy; {new Date().getFullYear()} Elumity</p>
                    </div>
                    {footerSections.map(({ name, links }, index) => (
                        <ul key={index}>
                            <li>
                                <span className={header}>{name}</span>
                            </li>
                            {links.map(({ label, href, target, icon }, linkIndex) => (
                                <li key={linkIndex}>
                                    <span className={link}>
                                        <a href={href} rel="noopener noreferrer" target={target ? target : '_self'}>
                                            {icon ? icon : null}
                                            {label}
                                        </a>
                                    </span>
                                </li>
                            ))}
                        </ul>
                    ))}
                </div>
            </footer>
        </LayoutContainer>
    );
};
